import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';


export interface ReferralItem {
  AutoIndex?: number;
  ReferralID?: number;
  Category: string;
  TestName: string;
  TestCode: string;
}

export interface Referral {
  AutoIndex?: number;
  ExamID?: number;
  PID: string;
  GID: number;
  UID?: number;
  Opener?: string;
  OpenerTitle?: string;
  OpenerEngName?: string;
  OpenerDrNum?: string;
  OpenerExpertNum?: string;
  CreatedAt?: string;
  SignedAt?: string;
  Status?: string;
  Instructions?: string;
  PatFirst?: string;
  PatLast?: string;
  PatIDNum?: string;
  PatDOB?: string;
  HMO?: string;
  items?: ReferralItem[];
}

export interface ReferralSaveItem {
  category: string;
  name: string;
  code: string;
}

@Injectable({
  providedIn: 'root'
})
export class BloodTestReferralService {

  constructor(private http: HttpClient) {}

  create(pid: string, gid: number, examID?: number): Observable<{ AutoIndex: number }> {
    return this.http.post<{ AutoIndex: number }>('/api/referrals', { PID: pid, GID: gid, ExamID: examID || null });
  }

  getAll(pid: string, gid: number): Observable<Referral[]> {
    return this.http.get<Referral[]>(`/api/referrals/${pid}/${gid}`);
  }

  getByExam(examId: number): Observable<Referral | null> {
    return this.http.get<Referral | null>(`/api/referrals/byexam/${examId}`);
  }

  getOne(id: number): Observable<Referral> {
    return this.http.get<Referral>(`/api/referrals/single/${id}`);
  }

  save(id: number, items: ReferralSaveItem[], instructions: string): Observable<any> {
    return this.http.put(`/api/referrals/${id}/save`, { items, instructions });
  }

  sign(id: number): Observable<any> {
    return this.http.post(`/api/referrals/${id}/sign`, {});
  }

  updateStatus(id: number, status: string): Observable<any> {
    return this.http.put(`/api/referrals/${id}/status`, { status });
  }

  deleteReferral(id: number): Observable<any> {
    return this.http.delete(`/api/referrals/${id}`);
  }
}
